import React from "react";
import { Tabs, theme } from 'antd';
import PurchaseCTTListView from "../components/purchase/PurchaseCTTListView";
import PurchaseCTTStockListView from "../components/purchase/PurchaseCTTStockListView";


export default function PurchaseCTTView() {

  const {
    token: { colorPrimary },
  } = theme.useToken();

  const items = [
    {
      key: 'progress',
      label: 'รายการรับซื้อน้ำยางข้น',
      children  : <PurchaseCTTListView/>,
    },
    {
      key: 'all',
      label: 'สต๊อกนำเข้าคงเหลือ',
      children: <PurchaseCTTStockListView/>,
    },
  ];

  return(
    <div style={{ marginTop : 20}}>
      <Tabs 
        defaultActiveKey="task" 
        destroyInactiveTabPane
        items={items}
      />

    </div>
  )
}